import { Route } from 'react-router-dom'
import { StackDemoPage } from './StackDemoPage'

export function StackDemoRoutes() {
  return [
    <Route path="/demo/stack" element={<StackDemoPage />} />,
    <Route path="/demo/stack/:pageId" element={<StackDemoPage />} />,
  ]
}

